import { AuditEntityType, LegalEntityActiveStatusDto } from '@sr/dto';
import { legalEntitiesApi } from '../legal-entities.api';
import { LEGAL_ENTITY_BASE_URL } from '../../../shared/api/api';
import { invalidateEntityAudit } from 'entities/audit/utils';

const injectedApi = legalEntitiesApi.injectEndpoints({
  endpoints: (builder) => ({
    getLegalEntityActiveStatus: builder.query<LegalEntityActiveStatusDto, number>({
      query: (legalEntityId: number) => `${LEGAL_ENTITY_BASE_URL}/${legalEntityId}/active-status`,
    }),
    updateLegalEntityActiveStatus: builder.mutation<LegalEntityActiveStatusDto, { legalEntityId: number, data: LegalEntityActiveStatusDto }>({
      query: ({ legalEntityId, data }) => ({
        url: `${LEGAL_ENTITY_BASE_URL}/${legalEntityId}/active-status`,
        body: data,
        method: 'PUT'
      }),
      async onQueryStarted({ legalEntityId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          invalidateEntityAudit(dispatch, AuditEntityType.LEGAL_ENTITY, legalEntityId);
        } catch (error) {
          console.error(error);
        }
      },
    }),
  }),
});

export const legalEntitiesActiveStatusApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['legalEntityActiveStatus'],
  endpoints: {
    getLegalEntityActiveStatus: {
      providesTags: (result, _, legalEntityId) => (
        result ? [{ type: 'legalEntityActiveStatus', id: legalEntityId }] : ['legalEntityActiveStatus']
      ),
    },
    updateLegalEntityActiveStatus: {
      invalidatesTags: (res, error, query) => (
        res && !error ? [{ type: 'legalEntityActiveStatus', id: query.legalEntityId }] : ['legalEntityActiveStatus']
      ),
    },
  },
});
